module.exports = __webpack_public_path__ + "img/adapt.bbd46b17.svg";